import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "DemeritoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "DemeritoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexDemerito(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Persona', name: 'Persona', title: 'Persona' },
                { data: 'Demerito', name: 'Demerito', title: 'Demerito' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'Motivo', name: 'Motivo', title: 'Motivo' },
                { data: 'ImpuestoPor', name: 'ImpuestoPor', title: 'Impuesto Por' },
                { data: 'NroDocumento', name: 'NroDocumento', title: 'NroDocumento' },
                { data: 'Fecha', name: 'Fecha', title: 'Fecha' },
                { data: 'EstadoDocumento', name: 'EstadoDocumento', title: 'Estado Documento' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            demeritos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            demerito: {},
            
        };
    },
    methods: {
               
        newDemerito() {
            this.demerito = {};
            this.$refs['frm-demerito'].show();
            // console.log("hhhhola")
        },
        showDemerito(id) {
            this.isLoading=true;
            this.ss.showDemerito(id).then(
                (result) => {
                    let response = result.data;
                    this.demerito = response.data;
                    this.$refs['view-demerito'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editDemerito() {
            this.$refs['frm-demerito'].show();
            this.$refs['view-demerito'].hide();
        },
        cancelDemerito() {
            if (this.demerito.id) {
                this.$refs['view-demerito'].show();
            }
            this.$refs['frm-demerito'].hide();
        },
        saveDemerito() {
            this.ss.storeDemerito(this.demerito).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-demerito'].hide();
                    this.$refs['datatable-demerito'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteDemerito() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyDemerito(this.demerito)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-demerito'].hide();
                                this.$refs['datatable-demerito'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-demerito'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-demerito'].show();
        },
        changePassword() {
            this.password.Demerito = this.demerito.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-demerito'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-Demerito').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showDemerito(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
